import { AnimatePresence, motion } from "motion/react";
import styles from "./loader.module.css";
import { cn } from "@/lib/utils";

export function Loader({
  className,
  scale = 1,
}: {
  className?: string;
  scale?: number;
}) {
  const circleCn = cn(styles.circle, `dark:bg-[#EDEDF0] bg-[#2D2D31]`);

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.5 }}
      >
        <div
          className={cn(styles.gridContainer, className)}
          style={{
            scale,
          }}
        >
          <div className={styles.backgroundSquare}></div>

          {/* Row 1 */}
          <div></div>
          <div className={cn(circleCn, styles.size1)}></div>
          <div className={cn(circleCn, styles.size2)}></div>
          <div className={cn(circleCn, styles.size3)}></div>
          <div className={cn(circleCn, styles.size3)}></div>
          <div className={cn(circleCn, styles.size2)}></div>
          <div className={cn(circleCn, styles.size1)}></div>
          <div></div>

          {/* Row 2 */}
          <div className={cn(circleCn, styles.size2)}></div>
          <div className={cn(circleCn, styles.size3)}></div>
          <div className={cn(circleCn, styles.size4)}></div>
          <div className={cn(circleCn, styles.size5)}></div>
          <div className={cn(circleCn, styles.size5)}></div>
          <div className={cn(circleCn, styles.size4)}></div>
          <div className={cn(circleCn, styles.size3)}></div>
          <div className={cn(circleCn, styles.size2)}></div>

          {/* Row 3 */}
          <div className={cn(circleCn, styles.size3)}></div>
          <div className={cn(circleCn, styles.size4)}></div>
          <div className={cn(circleCn, styles.size8)}></div>
          <div className={cn(circleCn, styles.size8)}></div>
          <div className={cn(circleCn, styles.size8)}></div>
          <div className={cn(circleCn, styles.size8)}></div>
          <div className={cn(circleCn, styles.size4)}></div>
          <div className={cn(circleCn, styles.size3)}></div>

          {/* Row 4 */}
          <div className={cn(circleCn, styles.size3)}></div>
          <div className={cn(circleCn, styles.size5)}></div>
          <div className={cn(circleCn, styles.size8)}></div>
          <div className={cn(circleCn, styles.size9)}></div>
          <div className={cn(circleCn, styles.size9)}></div>
          <div className={cn(circleCn, styles.size8)}></div>
          <div className={cn(circleCn, styles.size5)}></div>
          <div className={cn(circleCn, styles.size3)}></div>

          {/* Row 5 */}
          <div className={cn(circleCn, styles.size3)}></div>
          <div className={cn(circleCn, styles.size5)}></div>
          <div className={cn(circleCn, styles.size8)}></div>
          <div className={cn(circleCn, styles.size9)}></div>
          <div className={cn(circleCn, styles.size9)}></div>
          <div className={cn(circleCn, styles.size8)}></div>
          <div className={cn(circleCn, styles.size5)}></div>
          <div className={cn(circleCn, styles.size3)}></div>

          {/* Row 6 */}
          <div className={cn(circleCn, styles.size3)}></div>
          <div className={cn(circleCn, styles.size4)}></div>
          <div className={cn(circleCn, styles.size8)}></div>
          <div className={cn(circleCn, styles.size8)}></div>
          <div className={cn(circleCn, styles.size8)}></div>
          <div className={cn(circleCn, styles.size8)}></div>
          <div className={cn(circleCn, styles.size4)}></div>
          <div className={cn(circleCn, styles.size3)}></div>

          {/* Row 7 */}
          <div className={cn(circleCn, styles.size2)}></div>
          <div className={cn(circleCn, styles.size3)}></div>
          <div className={cn(circleCn, styles.size4)}></div>
          <div className={cn(circleCn, styles.size5)}></div>
          <div className={cn(circleCn, styles.size5)}></div>
          <div className={cn(circleCn, styles.size4)}></div>
          <div className={cn(circleCn, styles.size3)}></div>
          <div className={cn(circleCn, styles.size2)}></div>

          {/* Row 8 */}
          <div></div>
          <div className={cn(circleCn, styles.size1)}></div>
          <div className={cn(circleCn, styles.size2)}></div>
          <div className={cn(circleCn, styles.size3)}></div>
          <div className={cn(circleCn, styles.size3)}></div>
          <div className={cn(circleCn, styles.size2)}></div>
          <div className={cn(circleCn, styles.size1)}></div>
          <div></div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
}
